import { render, staticRenderFns } from "./TkRefundPerson.vue?vue&type=template&id=aac4fc5a&scoped=true&"
import script from "./TkRefundPerson.vue?vue&type=script&lang=js&"
export * from "./TkRefundPerson.vue?vue&type=script&lang=js&"
import style0 from "./TkRefundPerson.vue?vue&type=style&index=0&id=aac4fc5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac4fc5a",
  null
  
)

export default component.exports